import { createContext, useContext, type ReactNode } from "react";

/**
 * Read-only Desk (subscription billing spec, section 2.3). When the business's Teamna plan is not
 * paid, the owner office wraps its pages in a `WriteLock` with the reason, and every `primary` and
 * `danger` button inside turns off and shows the reason. Those two variants are the writes: save,
 * add, send, remove. The API refuses the writes anyway (402 `BILLING_READ_ONLY`); this only tells
 * the owner before they press.
 *
 * A part of a page that stays open in read-only (the Billing page, attendance) wraps itself in
 * `<WriteLock reason={null}>`, and a single button that is not a write passes `readOnlySafe`.
 * Control Center never sets a lock: Teamna staff can fix data for a business in read-only.
 */
const WriteLockContext = createContext<string | null>(null);

export function WriteLock({ reason, children }: { reason: string | null; children: ReactNode }) {
  return <WriteLockContext.Provider value={reason}>{children}</WriteLockContext.Provider>;
}

/** The reason writes are off here, or null when they are on. */
export function useWriteLock(): string | null {
  return useContext(WriteLockContext);
}
